import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./authProvider";

const RequireClient = () => {
    const { user,isLoggedIn, isLoading } = useAuth();

    if (isLoading) return null;

    if (!user || !isLoggedIn){
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default RequireClient;